import React, { useEffect } from "react";
import { SalesPage } from "./components/SalesPage";
import { initMetaPixel } from "./utils/metaPixel";
export function App() {
  useEffect(() => {
    document.documentElement.lang = "en";
    document.title = "Senior Activity Hub | 10 Ready-to-Lead Activities + 5 Bonuses";
    const description = "Prepare your next senior living group session with 10 activities, printable materials, coordinator instructions, a 12-month calendar and 5 bonuses. $29 USD once.";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", "https://seniorsactivitys.stockdigital.shop/");
    initMetaPixel();
  }, []);
  return <SalesPage data-id="element-0" data-mp="3ii4sg33z0up3" />;
}